import { createContext, useContext, useReducer, useEffect } from "react";

import reducer from '../reducer/productreducer';
import axios from 'axios';
import { useAuthStore } from "store/store";

const AppContext = createContext();
const API = `${process.env.REACT_APP_SERVER_DOMAIN}/api/products`;
// const FILTER_API = "http://localhost:8080/api/products/filter";
const CATEGORY_API = `${process.env.REACT_APP_SERVER_DOMAIN}/api/products/categories`;
const SUBCATEGORY_API = `${process.env.REACT_APP_SERVER_DOMAIN}/api/products/subcategories`;

const initialState = {
  isLoading: false,
  isError: false,
  products: [],
  categories: [],
  subcategories: [],
  items: [],
  featureproducts: [],
  isSingleLoading: false,
  singleproduct: {},
  isProductLoading: false,
  singleproductInfo: {},


}
export async function fetchCategories() {
  const res = await axios.get(CATEGORY_API);
  return res.data; // [{ _id: "...", label: "bathtub" }, ...]
}

export async function fetchSubcategories() {
  const res = await axios.get(SUBCATEGORY_API);
  return res.data; // [{ _id: "...", label: "tub" }, ...]
}



const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const {auth}=useAuthStore();

  const getProducts = async (url) => {


    dispatch({ type: "Set_Loading" });
    try {
       const token = localStorage.getItem("token");
    let url = API; // default public route: /api/products
    let headers = {};

    if (token) {
      // decode JWT payload to check role
      const decoded = JSON.parse(atob(token.split('.')[1]));
      if (decoded.role === "admin") {
        url = `${API}/admin`; // admin route
        headers = { Authorization: `Bearer ${token}` };
      }
    }

    const res = await axios.get(url, { headers });
      const products = await res.data;
      // console.log("Fetched Products:", products);  //Debug API response
      dispatch({ type: "Set_Data", payload: products }); // Pass parsed data
    } catch (error) {
      //  console.error("Error fetching products:", error);
      dispatch({ type: "error" });
    }
  };

  const getCategories = async () => {
    try {
      const res = await axios.get(CATEGORY_API);
      dispatch({ type: "Set_Categories", payload: res.data });
    } catch (error) {
      dispatch({ type: "error" });
    }
  };

  const getSubcategories = async () => {
    try {
      const res = await axios.get(SUBCATEGORY_API);
      dispatch({ type: "Set_Subcategories", payload: res.data });
    } catch (error) {
      dispatch({ type: "error" });
    }
  };


  const getAllItems = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`);
      const products = res.data;
      const items = [...new Set(products.map(p => p.Item))];
      dispatch({ type: "Set_Items", payload: items });
    } catch (error) {
      dispatch({ type: "error" });
    }
  };



  // NEW: fetch subcategories for a specific category
  const getSubcategoriesByCategory = async (categoryId) => {
    try {
      const res = await axios.get(`${SUBCATEGORY_API}?category=${categoryId}`);
      dispatch({ type: "Set_Subcategories", payload: res.data });
    } catch (error) {
      dispatch({ type: "error" });
    }
  };

  const getItemsByCategory = async (categoryId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`, {
        params: { category: categoryId }
      });
      const products = res.data;

      const items = [...new Set(products.map(p => p.Item))];
      dispatch({ type: "Set_Items", payload: items });
    } catch (error) {
      dispatch({ type: "error" });
    }
  };


  // NEW: fetch items for a specific subcategory
  const getItemsBySubcategory = async (subcategoryId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`, {
        params: { subcategory: subcategoryId }
      });
      const products = res.data;

      // 👀 Debug: log Items before deduplication
      console.log("Items from backend (raw):", products.map(p => p.Item));


      // Extract unique Item names
      const items = [...new Set(products.map(p => p.Item))];

      dispatch({ type: "Set_Items", payload: items });
    } catch (error) {
      dispatch({ type: "error" });
    }

  };

  //FilterProducts-Fetching Products based on FilterLogic
  const getFilteredProducts = async ({ category, subcategory, Item, sort, text } = {}) => {
    dispatch({ type: "Set_Loading" });
    try {
      const params = {};

      if (category && category !== "All") params.category = category;
      if (subcategory && subcategory !== "All") params.subcategory = subcategory;
      // if (item && item !== "All") params.Item = item;
      if (Item && Item !== "All") params.Item = Item;   // ✅ use Item consistently
      // 👀 Debug log here
      // console.log("Filter params:", params);
      if (sort) params.sort = sort;   // ✅ add sorting param

      // ✅ NEW: include text search
      if (text && text.trim() !== "") params.text = text;






      const res = await axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`, { params });
      const products = res.data;

      dispatch({ type: "Set_Data", payload: products });
    } catch (error) {
      dispatch({ type: "error" });
    }

  };


  const getSingleProducts = async (url) => {
    dispatch({ type: "Set_Single_Loading" });
    try {
      const res = await axios.get(url);
      const singleproduct = res.data;
      //  console.log("Fetched Products:", singleproduct); 
      dispatch({ type: "Set_Single_Data", payload: singleproduct });
    } catch (error) {
      //  console.error("Error fetching products:", error);
      dispatch({ type: "single_error" });
    }
  };

  // for edit Product Form
  const getProductInfo = async (url) => {
    dispatch({ type: "Set_Product_Loading" });
    try {
      const res = await axios.get(url);
      const singleproductInfo = res.data;
      //  console.log("Fetched Products:", singleproduct); 
      dispatch({ type: "Set_Product_Data", payload: singleproductInfo });
    } catch (error) {
      //  console.error("Error fetching products:", error);
      dispatch({ type: "Product_error" });
    }
  };



  useEffect(() => {
    getProducts(API);
    getCategories();
    getSubcategories();
    getAllItems();

  }, [auth.isLoggedIn, auth.role]);

  return (
    <AppContext.Provider value={{ ...state, getProducts, getItemsByCategory, getItemsBySubcategory, getSubcategoriesByCategory, getFilteredProducts, getSingleProducts, getProductInfo, getCategories, getSubcategories, getAllItems }}>{children}</AppContext.Provider>
  )
};
//custom hook that removes the need of unnecesarily writing the import statements etc
const useProductContext = () => {
  return useContext(AppContext);
}

export { AppProvider, AppContext, useProductContext };

